<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'VFatherProTestsCo',
  components: {},
};
</script>
